module.exports = __webpack_public_path__ + "static/17gde-b382d00514872341109d9f05a9f7ff39.gif";